import React from "react";

export default function CentroDeleteModal({
  open,
  centro,
  deleting,
  onClose,
  onConfirm,
}) {
  if (!open) return null;

  return (
    <div
      className="modal fade show d-block management-modal centros-modal centros-modal--compact"
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header border-0">
            <div>
              <p className="dashboard-eyebrow mb-1 text-danger">Eliminar registro</p>
              <h5 className="modal-title mb-0 d-flex align-items-center gap-2">
                <i className="bi bi-exclamation-triangle"></i> Confirmar accion
              </h5>
            </div>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p className="mb-2">
              Estas seguro de que deseas eliminar el centro <strong>{centro?.nombre}</strong>?
            </p>
            <p className="text-muted mb-0">
              Esta accion no eliminara historicos, pero ya no aparecera en listados.
            </p>
          </div>
          <div className="modal-footer border-0 pt-0">
            <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="button" className="btn btn-danger text-white" disabled={deleting} onClick={onConfirm}>
              {deleting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Eliminando...
                </>
              ) : (
                "Eliminar"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
